import { getDomainName } from "./helper_functions";
import { LOGO_TYPE } from "./key_helper";
export const APP_VERSION = "v1.1.6";
export const ENV = "LIVE";  // Change this to "BETA", "LIVE" or "LOCAL" as needed
//API CONFIGURATION
const CONFIG = {
    LIVE: {
        BASE_URL: "https://api.algodeltafx.com",
        SECRET_KEY: "ALGODELTAFX_LIVE_KEY_ADFX_WP_USER_@2025",
    },
    BETA: {
        BASE_URL: "https://api.algodeltafx.com",
        SECRET_KEY: "ALGODELTAFX_BETA_KEYS_ADFX_WP_USER_@2025",
    },
    LOCAL: {
        BASE_URL: "http://192.168.1.7:3000",
        SECRET_KEY: "ALGODELTAFX_LOCAL_KEY_ADFX_WP_USER_@2025",
    }
};

export const { BASE_URL, SECRET_KEY } = CONFIG[ENV];
export const API_URL = `${BASE_URL}/api/v1`;
const WEBHOOK_FX_URL = "https://webhookfx.traderstoolkits.com/api/v1";
//  DOMAIN
export const domain_name_flat = getDomainName(true);
// WEBHOOK URL
export const WEB_HOOK_URL = `${WEBHOOK_FX_URL}/users/bridge/webhook/`;
export const TRADING_VIEW_BRIDGE_WEB_HOOK_URL = `${WEBHOOK_FX_URL}/users/bridge/webhook/tradingview/`;
// STATIC PATHS
export const USER_PROFILE_PATH = `${BASE_URL}/whitelabeluser_profiles/`;
// SECURITY KEY
export const RECAPTCHA_SITE_KEY = "6Ld6zjorAAAAAPNdJtr8dlCxRzax8ScvfTdqiXIb"
// BRAND LOGO PATHS
export const WHITE_LABEL_LOGO_PATH = `${BASE_URL}/whitelabel_images/`;
export const PORTAL_LOGO_MINI = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.VERTICAL_LOGO}.jpg`;
export const PORTAL_LOGO_LONG = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.HORIZONTAL_LOGO}.jpg`;
